export default __webpack_public_path__ + "static/media/owl-white.0be04517.svg";